import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';

import { ActualButton as Button, Cluster } from '@nearst/ui';

import PageLayout from '../PageLayout';

import styles from './Confirmation.module.scss';

const Confirmation = ({ email }) => {
	const [confette, setConfette] = useState();

	const navigate = useNavigate();
	const takeToLogin = () => {
		navigate('/login');
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			setConfette(3);
		}, 2000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<PageLayout>
			<Confetti data-cy="confette" {...useWindowSize()} numberOfPieces={confette} />
			<h1>You are all signed up!</h1>
			<p className={styles.confirm}>
				You are now ready to login to your Dashboard where you can complete your NearSt profile and start uploading your inventory
			</p>
			<Cluster>
				<Button primary onClick={takeToLogin}>
					Login
				</Button>
				<Button onClick={() => (window.location.href = 'mailto:support@near.st')}>Contact us</Button>
				<p>If you have any questions, don&#39;t hesitate to reach out to our team through live chat support</p>
			</Cluster>
		</PageLayout>
	);
};

export default Confirmation;
